// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2fRQj","container":"styles_container__1e0YH","title":"styles_title__2CfAC","wrapper":"styles_wrapper__3d6iG","answer":"styles_answer__266nn"};